export default __webpack_public_path__ + "static/media/iconmonstr-whatsapp-1-240.d70cdef9.png";